import * as PIXI from 'pixi.js';
import {getNearestTierTexture, Ship} from '@game/ships/ship';
import {HullSize, ShipGameObject} from '@game/ships/ship.game-object';
import {ExhaustGameObject} from '@game/ships/parts/exhaust.game-object';
import {ShipCreateOptions} from '@game/ships/ship.factory';

export class FrigateTurtleGameObject extends ShipGameObject {

  constructor(ship: Ship, opts: ShipCreateOptions) {
    super(ship, opts);

    // Center
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: -1,
      x: -10,
      y: 25,
      scale: 2.5,
    }));

    // Right
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: 1,
      x: 14,
      y: 25,
      scale: 2.5,
    }));

    const shipTexture = getNearestTierTexture(ship.getHighestModuleTier(), 'ships', 'frigate_turtle_t%.png')
    if (shipTexture) {
      const sprite = new PIXI.Sprite(shipTexture);
      this.addChild(sprite);
    }
  }

  getSize(): number {
    return HullSize.Large;
  }
}
